module.exports = __webpack_public_path__ + "static/media/1015822.d3c48adc.png";